import { render, staticRenderFns } from "./groupPopupPc.vue?vue&type=template&id=2a5bfe50&scoped=true"
import script from "./groupPopupPc.vue?vue&type=script&lang=ts"
export * from "./groupPopupPc.vue?vue&type=script&lang=ts"
import style0 from "./groupPopupPc.vue?vue&type=style&index=0&id=2a5bfe50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5bfe50",
  null
  
)

export default component.exports